import React, { Component } from "react";
import styled from "styled-components";
import Image from "../Image";
import WorldBeanIntro from "../../../content/WorldBeanIntro";

class WorldBeanIntroItem extends Component {
  state = {
    data: null
  };

  componentDidMount() {
    let { country } = this.props;
    if (country) {
      this.setState({
        data: WorldBeanIntro.filter(
          WorldBeanIntro => country == WorldBeanIntro.country
        )[0]
      });
    }
  }

  render() {
    let { data } = this.state;

    return (
      <Wrapper>
        {(() => {
          if (!data) {
            return <div />;
          } else {
            return (
              <>
                <ImageContainer>
                  <Image src={data.img} background />
                </ImageContainer>
                <DetailContainer>
                  <div className="text">
                    <h1>
                      {data.country || "---"}({data.country_name})
                    </h1>
                    <p className="bold">{data.description}</p>
                    <p>{data.content}</p>
                  </div>
                </DetailContainer>
              </>
            );
          }
        })()}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  margin-top: 20px;
  width: 500px;
  display: flex;
  flex-direction: column;
  background: white;

  @media screen and (max-width: 600px) {
    max-width: 400px;
  }

  @media screen and (max-width: 414px) {
    max-width: 300px;
  }

  ${props => props.css}
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 280px;
`;

const DetailContainer = styled.div`
  padding: 15px;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  padding: 25px;

  & h1 {
    font-weight: 400px;
    font-size: 26px;
    color: #4e4e4e;
    margin-bottom: 20px;
  }

  & .text {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    & > .bold {
      font-weight: bold;
    }

    & > p {
      white-space: pre-wrap;
      font-size: 14px;
      line-height: 30px;
      color: #4e4e4e;
    }
  }
`;

export default WorldBeanIntroItem;
